// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import ClaimSearchResult from '@deere/cps-it.warranty-model-factory/lib/claim-search-result';
import {FormattedMessage} from 'react-intl';
import NumberOfRecordsFound from '../../../../shared/components/number-of-records-found/index';
import ReportGrid from '../../../shared/components/report-grid';
import ReportHeader from '../../../shared/components/report-header';
import ReportHiddenColumns from '../../../shared/components/report-columns';
import WarrantyAgGridDatePicker from '../../../shared/components/ag-grid-date-picker';
import {getAdvancedClaimSummaryColumnDefinitions} from '../../report-services/column-definitions';
import {getAgGridLocaleText} from '../../../../shared/utils/ag-grid-locale-text';
import {getSelectedRows} from '../../../shared/services/get-selected-rows-from-in-memory-rows';

function handleSelectDeselectAll() {

    this.showSelectAll ? this.gridApi.selectAllFiltered() : this.gridApi.deselectAllFiltered();
    this.onUpdateShowSelectAll(!this.showSelectAll);

}

function handlePrintClaims() {

    const claims = getSelectedRows(this.gridApi.getModel().rowsToDisplay);

    this.onPrintClaims(claims);

}

function onColumnRemoved(columnEvent) {

    this.hideReportColumn(columnEvent);

}

function handleGridApiDefinition(params) {

    this.onCreateAgGridApi(params);

}

function handleRowSelection() {

    const isDisabled = this.gridApi.getSelectedRows().length < 1;

    this.updateDisabled(isDisabled);

}

const ReportContainer = props => {

    const gridOptions = {
        dateComponentFramework: WarrantyAgGridDatePicker
    };

    return (
        <div>
            <NumberOfRecordsFound count={props.report.length}/>
            <section className='report'>
                {props.reportVariant.isReportColumnsVisible && <ReportHiddenColumns/>}
                <ReportHeader
                    columnApi={props.columnApi}
                    gridApi={props.gridApi}
                    reportName='advanced-claim-summary'
                >
                    <div className='report-buttons'>
                        <button onClick={props::handleSelectDeselectAll}>
                            {props.showSelectAll ?
                                <FormattedMessage id='SELECT_ALL'/> :
                                <FormattedMessage id='DESELECT_ALL'/>
                            }
                        </button>
                        <button
                            disabled={props.isPrintClaimDisabled}
                            onClick={props::handlePrintClaims}
                        >
                            <FormattedMessage id='DISPLAY_CLAIM'/>
                        </button>
                    </div>
                </ReportHeader>
                <ReportGrid
                    columnDefs={getAdvancedClaimSummaryColumnDefinitions()}
                    gridOptions={gridOptions}
                    localeText={getAgGridLocaleText()}
                    onColumnVisible={props::onColumnRemoved}
                    onGridReady={props::handleGridApiDefinition}
                    onRowSelected={props::handleRowSelection}
                    rowData={props.report}
                    rowDeselection={true}
                    rowSelection='multiple'
                />
            </section>
        </div>
    );

};

ReportContainer.displayName = 'ReportContainer';
ReportContainer.propTypes = {
    columnApi: PropTypes.object.isRequired,
    gridApi: PropTypes.object.isRequired,
    hideReportColumn: PropTypes.func.isRequired,
    isPrintClaimDisabled: PropTypes.bool.isRequired,
    onCreateAgGridApi: PropTypes.func.isRequired,
    onPrintClaims: PropTypes.func.isRequired,
    onUpdateShowSelectAll: PropTypes.func.isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(ClaimSearchResult)).isRequired,
    reportVariant: PropTypes.object.isRequired,
    showSelectAll: PropTypes.bool.isRequired,
    updateDisabled: PropTypes.func.isRequired
};

export default ReportContainer;



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/components/report-container/index.js